import { Component, OnInit, OnDestroy, ElementRef, ViewChild} from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { AuthorizePaymentService } from '../../services/api/authorize-payment.service';
import { addCreditCard, addCreditCardResponse, NotifyCreditCardAddRequest, NotifyCreditCardAddResponse,
      getTokenPage, getTokenPageResponse, NotifyTokenAddRequest, NotifyTokenAddResponse} from 'src/app/shared/models/authorizeNet.model';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiEndpoints } from 'src/config/api-endpoints';

declare global {
  interface Window {
    AuthorizeNetIFrame?: any;
  }
}

@Component({
  selector: 'app-hosted-payment',
  templateUrl: './hosted-payment.component.html',
  styleUrls: ['./hosted-payment.component.scss']
})
export class HostedPaymentComponent implements OnInit, OnDestroy {

   loading: boolean = false;
   systemError: boolean = false;
   addCreditCardForm: SafeHtml | null = null; // Change the type to SafeHtml
   private subscription: Subscription = new Subscription(); // To store the subscription
   @ViewChild('addPaymentIframe') addPaymentIframe: ElementRef | undefined; // Get a reference to the iframe
    paymentSuccessful: boolean = false; 
   private communicatorUrl: string = 'src/assets/web/hostedPaymentIFrameCommunicatorUrl.html'; 

    // Track whether the form has been submitted and is waiting for redirect
   private awaitingExternalRedirect: boolean = false; 


    private notifyUserId = sessionStorage.getItem('PPIUserID');
   private notifyCustomerId = sessionStorage.getItem('PPICustomerID');

   constructor(private router: Router,
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private authorizePaymentService: AuthorizePaymentService 

  ){ }

  ngOnInit() {
      this.setupAuthorizeNetIFrameCommunication();
    this.loadHostedPaymentForm();
  }

   ngOnDestroy() {
     if (this.subscription) {
       this.subscription.unsubscribe();
     }
     // Clean up the global function
     if (window.AuthorizeNetIFrame && window.AuthorizeNetIFrame.onReceiveCommunication) {
       delete window.AuthorizeNetIFrame.onReceiveCommunication;
     }
   }

    private loadHostedPaymentForm() {
    this.loading = true;

    const walletID = sessionStorage.getItem('WalletID')?.replace(/"/g, '') || '';
    const sessionID = sessionStorage.getItem('SessionID') || '';
    const userID = sessionStorage.getItem('PPIUserID') || ''; // ✅ pull from session storage

    const getNewTokenPageRequest: getTokenPage = {
      walletID,
      sessionID,
      userID
    };

    console.log('DEBUG getTokenPage payload:', getNewTokenPageRequest);

    this.subscription = this.authorizePaymentService.getNewTokenPage(getNewTokenPageRequest).subscribe({
      next: (response: getTokenPageResponse) => {
        this.loading = false;
        if (response.success) {
          const formToken = response.data.addForm.match(/value='([^']*)'/)?.[1];
          if (formToken) {
            this.loadIframeWithForm(formToken);
          } else {
            console.error('Form token not found in DWGetNewTokenPage response.');
            this.systemError = true;
          }
        } else {
          console.error('Failed to load hosted payment form:', response.message);
          this.systemError = true;
        }
      },
      error: (err) => {
        this.loading = false;
        console.error('Error calling DWGetNewTokenPage API:', err);
        this.systemError = true;
      }
    });
  }

    private loadIframeWithForm(formToken: string) {
          const form = document.createElement('form');
          form.setAttribute('id', 'send_token');
          form.setAttribute('method', 'post');
          form.setAttribute('action', ApiEndpoints.authorizenetaddpayment);
          form.setAttribute('target', 'authorizeNetIframe');

        // Add token input
          const tokenInput = document.createElement('input');
          tokenInput.setAttribute('type', 'hidden');
          tokenInput.setAttribute('name', 'token');
          tokenInput.setAttribute('value', formToken);
          form.appendChild(tokenInput);

            // ✅ Add communicator input
          const communicatorInput = document.createElement('input');
          communicatorInput.setAttribute('type', 'hidden');
          communicatorInput.setAttribute('name', 'hostedPaymentIFrameCommunicatorUrl');
          communicatorInput.setAttribute(
                'value', 
                `${environment.walletAPPUrl}/assets/web/hostedPaymentIFrameCommunicatorUrl.html`);
          form.appendChild(communicatorInput);


          document.body.appendChild(form);
          console.log('Communicator URL set to:', communicatorInput.getAttribute('value'));

          form.submit();
          document.body.removeChild(form);

      // iframe visible after submitting
      if (this.addPaymentIframe?.nativeElement) {
          this.addPaymentIframe.nativeElement.style.visibility = 'visible';
        }
    }

// --- NEW: Centralized AuthorizeNetIFrame.onReceiveCommunication handler ---
  private setupAuthorizeNetIFrameCommunication(): void {
    const component = this;

    window.AuthorizeNetIFrame = {
      onReceiveCommunication: (querystr: string) => {
        console.log('%c[Authorize.Net Message Received]', 'color: green; font-weight: bold;', querystr);
        const params = component.parseQueryString(querystr);
        console.log('%c[Parsed Params]', 'color: blue;', params);
        switch (params['action']) {
          case 'successfulSave':
            console.log('Credit card saved successfully');

            const walletID = sessionStorage.getItem('WalletID')?.replace(/"/g, '') || '';
            const sessionID = sessionStorage.getItem('SessionID') || '';
            const userID = sessionStorage.getItem('PPIUserID') || '';

            const notifyRequest: NotifyTokenAddRequest = {
              walletID,
              sessionID,
              userID
            };

            console.log('DEBUG notifyTokenAdd payload:', notifyRequest);

            component.authorizePaymentService.notifyTokenAdd(notifyRequest).subscribe({
              next: (response: NotifyTokenAddResponse) => {
                if (response.success) {
                  console.log('DWNotifyTokenAdd API call successful:', response);
                   window.top.location.href = '/preferences/manage-payment';
                //  component.router.navigate(['/preferences/manage-payment']);
                } else {
                  console.error('DWNotifyTokenAdd API call failed:', response.message);
                  component.systemError = true;
                }
              },
              error: (err) => {
                console.error('Error calling DWNotifyTokenAdd API:', err);
                component.systemError = true;
              }
            });
            break;

          case 'cancel':
            console.log('Payment process cancelled');
             window.top.location.href = '/preferences/manage-payment';
           // component.router.navigate(['/preferences/manage-payment']);
            break;

          case 'resizeWindow':
            const w = parseInt(params['width']);
            const h = parseInt(params['height']);
            const ifrm = window.document.getElementById('add_payment') as HTMLIFrameElement;
            if (ifrm) {
              ifrm.style.width = w + 'px';
              ifrm.style.height = h + 'px';
            }
            break;

          case 'transactResponse':
            console.log('Transaction response:', params);
            const ifrm2 = window.document.getElementById('add_payment') as HTMLIFrameElement;
            if (ifrm2) ifrm2.style.display = 'none';
            break;

          default:
            console.log('Unknown action:', params['action']);
        }
      }
    };
  }


// Helper function for parsing query strings (moved inside the component for better encapsulation)
private parseQueryString(str: string): { [key: string]: string } {
    const vars: { [key: string]: string } = {};
    const arr = str.split('&');
    for (let i = 0; i < arr.length; i++) {
        const pair = arr[i].split('=');
        vars[pair[0]] = decodeURIComponent(pair[1]);
    }
    return vars;
}


}


 // Define AuthorizeNetIFrame.onReceiveCommunication globally
//  window.AuthorizeNetIFrame = {
//    onReceiveCommunication: (querystr: string) => {
//      const params = parseQueryString(querystr);
//      switch (params["action"]) {
//        case "successfulSave":
//          console.log("Credit card saved successfully");
//          // Handle successful save (e.g., show a success message, navigate to another page)
//          break;
//        case "cancel":
//          console.log("Payment process cancelled");
//          // Handle cancellation (e.g., show a message, go back to invoice)
//          break;
//        case "resizeWindow":
//          const w = parseInt(params["width"]);
//          const h = parseInt(params["height"]);
//          if (window.document.getElementById("add_payment")) { // defensive check.
//             const ifrm = window.document.getElementById("add_payment") as HTMLIFrameElement;
//             ifrm.style.width = w.toString() + "px";
//             ifrm.style.height = h.toString() + "px";
//          }
//          break;
//        case "transactResponse":
//          console.log("Transaction response:", params);
//          if (window.document.getElementById("add_payment")) {
//             const ifrm = window.document.getElementById("add_payment") as HTMLIFrameElement;
//             ifrm.style.display = 'none';
//          }

//          // Handle transaction response (e.g., show result, process order)
//          break;
//        default:
//          console.log("Unknown action:", params["action"]);
//      }

//      function parseQueryString(str: string): { [key: string]: string } {
//        const vars: { [key: string]: string } = {};
//        const arr = str.split('&');
//        for (let i = 0; i < arr.length; i++) {
//          const pair = arr[i].split('=');
//          vars[pair[0]] = decodeURIComponent(pair[1]); // Use decodeURIComponent
//        }
//        return vars;
//      }
//    }
//  };

